export class WebWorker {
    constructor() {
        this.workerFunctionToUrlMap = new WeakMap();
        this.promiseToWorkerMap = new WeakMap();
    }

    run(workerFunction, data) {
        const url = this.getOrCreateWorkerUrl(workerFunction);
        return this.runUrl(url, data);
    }

    runUrl(url, data) {
        const worker = new Worker(url);
        const promise = this.createPromiseForWorker(worker, data);
        const promiseCleaner = this.createPromiseCleaner(promise);
        this.promiseToWorkerMap.set(promise, worker);
        return promise
            .then(promiseCleaner)
            .catch(promiseCleaner);
    }

    terminate(promise) {
        return this.removePromise(promise);
    }

    getWorker(promise) {
        return this.promiseToWorkerMap.get(promise);
    }

    createPromiseForWorker(worker, data) {
        return new Promise((resolve, reject) => {
            worker.addEventListener('message', event => resolve(event.data));
            worker.addEventListener('error', reject);
            worker.postMessage(data);
        });
    }

    getOrCreateWorkerUrl(fn) {
        if (!this.workerFunctionToUrlMap.has(fn)) {
            const url = this.createWorkerUrl(fn);
            this.workerFunctionToUrlMap.set(fn, url);
            return url;
        }
        return this.workerFunctionToUrlMap.get(fn);
    }

    createWorkerUrl(resolve) {
        const resolveString = resolve.toString();
        const webWorkerTemplate = `
            self.addEventListener('message', (e) => {
                postMessage((${resolveString})(e.data));
            });
        `;
        const blob = new Blob([webWorkerTemplate], { type: 'text/javascript' });
        return URL.createObjectURL(blob);
    }

    createPromiseCleaner(promise) {
        const _this = this;
        return event => {
            _this.removePromise(promise);
            return event;
        };
    }

    removePromise(promise) {
        const worker = this.promiseToWorkerMap.get(promise);
        if (worker) {
            worker.terminate();
        }
        this.promiseToWorkerMap.delete(promise);
        return promise;
    }
}

export const webWorker = new WebWorker();



// WEBPACK FOOTER //
// ./src/scripts/shared/WebWorker.js